module.exports = "module.exports = __webpack_public_path__ + \"../html/navigation.html\";";